import * as React from "react"

import { ActionAnchor } from "@tenforce/toolbox-button-push-react"

interface Props {
    label?: string
    url: string
    icon: string
    title: string
    isInverted: boolean
}

export const ContentWidgetListItem = ({
    label,
    url,
    icon,
    title,
    isInverted,
}: Props): JSX.Element => (
    <div className={isInverted ? "is-inverted" : ""}>
        <ActionAnchor
            href={url}
            extraClasses="theme-thumb"
            data-ft-content-list-item={title.toLowerCase()}
        >
            <h3 className="text-action tw-mr-2">{icon}</h3>
            <div>
                {!!label && (
                    <div
                        className={`label text-black is-dimmed ${
                            isInverted ? "is-inverted" : ""
                        }`}
                    >
                        {label}
                    </div>
                )}
                <div className="p text-action">{title}</div>
            </div>
        </ActionAnchor>
    </div>
)

ContentWidgetListItem.defaultProps = {
    isInverted: false,
}

export default ContentWidgetListItem
